class Education {
  constructor(school, degree, date) {
    this.school = school;
    this.degree = degree;
    this.date = date;
  }
}

const odu = new Education(
  "Old Dominion University",
  "Bachelor of Science in Criminal Justice",
  "May 2014",
);

const ada = new Education(
  "Ada Developers Academy",
  "Software Development Bootcamp",
  "January 2024",
);

const wgu = new Education(
  "Western Governors University",
  "Bachelor of Science in Computer Science",
  "April 2026",
);

let education = [odu, ada, wgu];

export default education;
